import dragon from './dragon_invite/ja.json';
import exchangeShop from './exchange_shop/ja.json';

export default {
    ...dragon,
    ...exchangeShop
};
